<div class="design-data-container">
  <em-image-spinner
    *ngIf="!!design"
    [src]="design.imageUrl"
    alt="Design image"
    class="design-image"
  ></em-image-spinner>
  <div class="break"></div>
  <nz-row [nzGutter]="64" class="details">
    <nz-col [nzSpan]="4">
      <nz-statistic [nzValueTemplate]="idTpl" nzTitle="Design ID"></nz-statistic>
      <ng-template #idTpl>
        <div class="detail-value">
          <em-display-property [value]="designIdTpl"></em-display-property>
          <ng-template #designIdTpl>
            {{ design?.designId }}
            <br />
            {{ design?.designDescription }}
          </ng-template>
        </div>
      </ng-template>
    </nz-col>
    <nz-col [nzSpan]="4">
      <nz-statistic [nzValueTemplate]="userTpl" nzTitle="Responsible User"></nz-statistic>
      <ng-template #userTpl>
        <div class="detail-value">
          <em-display-property
            value="({{ design?.responsibleUser }}) {{ design?.responsibleName }}"
          ></em-display-property>
          <button
            nz-button
            nzType="primary"
            routerLink="."
            [queryParams]="design?.designId | emApplyPure: designRouteParam.edit"
            queryParamsHandling="merge"
            nz-tooltip
            nzTooltipTitle="Edit responsible user"
          >
            <i nz-icon nzType="edit" nzTheme="fill"></i>
          </button>
        </div>
      </ng-template>
    </nz-col>
    <nz-col [nzSpan]="4">
      <nz-statistic [nzValueTemplate]="designerTpl" nzTitle="Designer"></nz-statistic>
      <ng-template #designerTpl>
        <div class="detail-value">
          <em-display-property
            value="{{ design?.designerName }} ({{ design?.designer }})"
          ></em-display-property>
        </div>
      </ng-template>
    </nz-col>
    <nz-col [nzSpan]="4" *emVisibleForRoles="['Novelty', 'Mould Engineering']">
      <nz-statistic [nzValueTemplate]="makeBuyTpl" nzTitle="Make/Buy"></nz-statistic>
      <ng-template #makeBuyTpl>
        <div class="detail-value">
          <em-display-property [value]="design?.makeBuy ?? ''"></em-display-property>
        </div>
      </ng-template>
    </nz-col>
    <nz-col [nzSpan]="4">
      <nz-statistic
        [nzValueTemplate]="launchDescriptionTpl"
        nzTitle="Launch Description"
      ></nz-statistic>
      <ng-template #launchDescriptionTpl>
        <div class="detail-value">
          <em-display-property [value]="design?.launchDescription ?? ''"></em-display-property>
        </div>
      </ng-template>
    </nz-col>
    <nz-col [nzSpan]="4">
      <nz-statistic [nzValueTemplate]="globalLaunchDateTpl" nzTitle="Launch Date"></nz-statistic>
      <ng-template #globalLaunchDateTpl>
        <div class="detail-value">
          <em-display-property
            [value]="(design?.globalLaunchDate | date: 'shortDate') ?? ''"
          ></em-display-property>
        </div>
      </ng-template>
    </nz-col>
  </nz-row>
</div>
